module.exports = __webpack_public_path__ + "img/arcos-c-img-1.2bfa1563.jpg";